import React from 'react'
import PropTypes from 'prop-types'
import FacebookIcon from 'media/facebook-logo.svg?svgr-webpack'
import TwitterIcon from 'media/twitter-logo.svg?svgr-webpack'
import PinterestIcon from 'media/pinterest-logo.svg?svgr-webpack'
import { isSSR } from 'js/isSSR'
export default function ShareButtons({ title }) {
  if (isSSR) return null

  const buttons = [
    {
      id: 'facebook',
      text: 'Facebook',
      url: `https://www.facebook.com/sharer/sharer.php?u=${document.location.href}`,
      icon: FacebookIcon,
    },
    {
      id: 'twitter',
      text: 'Tweet',
      url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        title.split(/ [–-]/).pop(),
      )}+${document.location.href}+%40Lifesum`,
      icon: TwitterIcon,
    },
    {
      id: 'pinterest',
      text: 'Save pin',
      url: `http://pinterest.com/pin/create/button/?url=${
        document.location.href
      }&description=${title.split(/ [–-]/).pop()}`,
      icon: PinterestIcon,
    },
  ]

  const popup = (e) => {
    e.preventDefault()

    const url = e.currentTarget.getAttribute('href')
    const title = e.currentTarget.textContent

    const w = 580
    const h = 470

    const dualScreenLeft =
      window.screenLeft !== undefined ? window.screenLeft : screen.left
    const dualScreenTop =
      window.screenTop !== undefined ? window.screenTop : screen.top

    const width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : screen.width
    const height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : screen.height

    const left = width / 2 - w / 2 + dualScreenLeft
    const top = height / 3 - h / 3 + dualScreenTop

    const newWindow = window.open(
      url,
      title,
      `scrollbars=yes, width=${w}, height=${h}, top=${top}, left=${left}`,
    )

    if (newWindow && newWindow.focus) newWindow.focus()
  }

  const classes = {
    facebook: 'c-share__item--facebook',
    twitter: 'c-share__item--twitter',
    pinterest: 'c-share__item--pinterest',
  }

  return (
    <div className="c-share text-center">
      {/* <h2 className="font-bold mb-16">Share this post</h2> */}
      <ul className="c-share__list">
        {buttons.map(({ id, text, url, icon: Icon }) => {
          return (
            <li key={id} className={`c-share__item ${classes[id]}`}>
              <a
                className="c-share__button"
                href={url}
                onClick={(e) => popup(e)}
              >
                <Icon className="c-share__icon" />
                <span className="c-share__text">{text}</span>
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

ShareButtons.propTypes = {
  title: PropTypes.string,
}
